module.exports = __webpack_public_path__ + "ab940b4b850fbdc5b76d7a8f62e6c119.png";